import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7083e0a5"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7083e0a5&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7083e0a5')) {
      api.createRecord('7083e0a5', component.options)
    } else {
      api.reload('7083e0a5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7083e0a5", function () {
      api.rerender('7083e0a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/BjImportFile/index.vue"
export default component.exports